import React from "react";
import { App, notification } from "antd";

const normalizeDescription = (desc) => {
    let data = desc?.response ? desc?.response?.data : desc;
    if (data?.message) {
        data = data?.message;
    }
    return data;
};

const buildNotificationOptions = (type, title, desc) => {
    const description = normalizeDescription(desc);
    return {
        message: <span style={{ color: "#111827" }}>{title}</span>,
        description: <span style={{ color: "#374151" }}>{description}</span>,
        placement: "bottomRight",
        className: "admin-notification admin-toast",
        style: {
            background: "#ffffff",
            color: "#111827",
        },
    };
};

// Hook for using toast notifications (Recommended - No warnings)
export const useToast = () => {
    const { notification: notificationApi } = App.useApp();

    const Toast = (type, title, desc) => {
        notificationApi[type](buildNotificationOptions(type, title, desc));
    };

    return Toast;
};

// Legacy export for backward compatibility (will show warning)
export const Toast = (type, title, desc) => {
    notification[type](buildNotificationOptions(type, title, desc));
};
